import React from 'react'
import { useFormContext } from 'react-hook-form'
import { FormattedMessage, useIntl } from 'react-intl'

import s from './styles.module.scss'

import { TTCLabel } from '../../../../../../../../../atoms'
import { Divider } from '../../../../../../../../../atoms/divider/Divider'
import {
  ControlledSwitchField,
  ControlledTextField,
} from '../../../../../../../../../forms'
import ControlledSelectField from '../../../../../../../../../forms/select-field/ControlledSelectField'
import { formatMoney } from '../../../../../../../shared/utils/format/format-money/format-money'
import { getVatRateOptions } from '../../../../../../../shared/utils/house-options.utils'
import {
  HouseNightlyTripGlobalFieldFormProps,
  HouseNightlyTripGlobalFieldProps,
} from '../../../form-container/HouseNightlyTripGlobalFormContainer'

const HouseNightlyTripGlobalHouseHoldFields = ({
  control,
  currencyArea,
  isFieldDisabled,
}: HouseNightlyTripGlobalFieldProps) => {
  const intl = useIntl()
  const { watch } = useFormContext<HouseNightlyTripGlobalFieldFormProps>()

  const isNotIncluded = !watch('options.houseHold.isIncluded')

  return (
    <>
      <ControlledSwitchField
        control={control}
        name='options.houseHold.isIncluded'
        label={intl.formatMessage({
          defaultMessage:
            'Le ménage et le linge sont-ils inclus dans le prix ?',
          id: 'ui.HouseNightlyTripGlobalHouseHoldFields.label',
        })}
        inline={true}
        disabled={isFieldDisabled}
      />

      {isNotIncluded ? (
        <>
          <Divider />

          <ControlledTextField
            control={control}
            name='options.houseHold.cleaningPrice'
            disabled={isFieldDisabled}
            type='number'
            inline={true}
            rules={{}}
            formatValue={(value) =>
              formatMoney({ value, currency: currencyArea.currency })
            }
            placeholder={formatMoney({
              value: 0,
              currency: currencyArea.currency,
            })}
            label={
              <>
                <FormattedMessage
                  id='ui.HouseCleaningLaundry.cleaningPrice'
                  defaultMessage='Prix du ménage par séjour'
                />
                <span style={{ marginLeft: 5 }}>
                  <TTCLabel />
                </span>
              </>
            }
          />

          <ControlledTextField
            control={control}
            name='options.houseHold.laundryPrice'
            disabled={isFieldDisabled}
            type='number'
            inline={true}
            rules={{}}
            formatValue={(value) =>
              formatMoney({ value, currency: currencyArea.currency })
            }
            placeholder={formatMoney({
              value: 0,
              currency: currencyArea.currency,
            })}
            label={
              <>
                <FormattedMessage
                  id='ui.HouseCleaningLaundry.laundryPrice'
                  defaultMessage='Prix du linge par séjour '
                />
                <span style={{ marginLeft: 5 }}>
                  <TTCLabel />
                </span>
              </>
            }
          />

          <div className={s.vatRate}>
            <ControlledSelectField
              control={control}
              rules={{ required: 'Champ requis.' }}
              name='options.houseHold.vatRate'
              labelClassName={s.vatRateLabel}
              inline={true}
              menuPlacement='top'
              label={intl.formatMessage({
                defaultMessage:
                  'TVA applicable aux suppléments ménage et linge de maison',
                id: 'ui.HouseNightlyTripGlobalHouseHoldFields.vatRate',
              })}
              options={getVatRateOptions(currencyArea.vatRates)}
              disabled={isFieldDisabled}
              placeholder={intl.formatNumber(0, {
                style: 'percent',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            />
          </div>
        </>
      ) : null}
    </>
  )
}

export default HouseNightlyTripGlobalHouseHoldFields
